

// for formatting inputs. In the input component, this is fired when the $ sign no longer works.
// note that there is no type checking here. All of that has to be in the validator functions.
// note that formatters are only considered on TEXT fields

import {format, parse, parseISO} from 'date-fns'


const formatters = {

    USDCurrency: {
        formatter: (val) => {
            if (!val && val !== 0) return;
            const options = { style: 'currency', currency: 'USD' };
            let input = val.toString().replace(/[^0-9.]/g, '');
            return new Intl.NumberFormat('en-US', options).format(parseFloat(input));
        }
    },



    percentage: {
        formatter: (val, decimals =1) => {
            if (!val && val !== 0) return null;
            let input = val.toString().replace(/[^0-9.]/g, '');
            return (parseFloat(input)/100).toLocaleString(undefined,{style: 'percent', minimumFractionDigits:decimals});
        }
    },

    number: {
        formatter: (val, decimals =0) => {
            if (!val && val !== 0) return null;
            let input = val.toString().replace(/[^0-9.]/g, '');
            return (parseInt(input)).toLocaleString();
        }
    },

    doubleDigitFloat: {
        formatter: val => {
            if (!val && val !== 0) return null;
            let input = val.toString().replace(/[^0-9.]/g, '');
            return ((parseFloat(input) * 100)  /100)
        }
    },

    phone: {
        formatter: val => {
            // Filter only numbers from the input
            let cleaned = ('' + val).replace(/\D/g, '');

            // Check if the input is of correct
            let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

            if (match) {
                // Remove the matched extension code
                // Change this to format for any country code.
                let intlCode = (match[1] ? '+1 ' : '')
                return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
            }

            return val;
        }
    },

    yesNo: {
        formatter: bool => {
            if (!bool) return "--"

            // sometimes true/false arrives as "true" and "false"
            if (["False", "false", "0"].includes(bool)) bool = false;

            return bool ? "Yes" : "No";
        }
    },


    loanSeniority: {
         formatter: val => {
             if (isNaN(+val)) return "Invalid Data"

             switch (+val) {
                 case 1:
                     return "First";
                 case 2:
                     return "Second";
                 case 3:
                     return "Junior";
                 default:
                     return "Invalid Data";
             }
         }
    },

    // todo: need to build a validator for this.
    date: (fromdateformat = 'iso', todateformat = 'LLLL d, yyyy') => {
        return {
            formatter: (val) => {
                if (!val) return;
                let dt;
                try {
                    if (fromdateformat === 'iso') {
                        dt = parseISO(val)
                    } else {
                        let input = val.replace(/\D/g, '');
                        dt = parse(input, fromdateformat, new Date())
                    }
                    return format(dt, todateformat)
                } catch {
                    return '~'
                }

            }
        }
    }
}


export default formatters;


